/**
 * Displays a compact badge for a game mode showing guess count / max guesses.
 * Applies won/lost/in-progress/unplayed styling via CSS class.
 *
 * @param {{ mode: string, modeStatuses: Object }} props
 * @param {string} props.mode - Game mode key (characters, quotes, music, locations, trivia, crafts, silhouette).
 * @param {Object} props.modeStatuses - Record of mode statuses from daily results.
 * @param {Object} [props.modeStatuses[mode]] - Status entry for this mode.
 * @param {number} props.modeStatuses[mode].count - Number of guesses used.
 * @param {string} props.modeStatuses[mode].status - Result status: "won" | "lost" | "in-progress" | "unplayed".
 * @returns {JSX.Element} A styled <span> badge.
 */
const ModeBadge = ({ mode, modeStatuses }) => {
  if (!modeStatuses || !modeStatuses[mode]) return <span className="mode-badge badge-unplayed">-</span>;
  const { count, status } = modeStatuses[mode];
  if (status === "unplayed") return <span className="mode-badge badge-unplayed">-</span>;

  const maxGuesses = {
    characters: 10,
    quotes: 6,
    music: 6,
    locations: 5,
    trivia: 2,
    crafts: 6,
    silhouette: 5
  }[mode];

  return (
    <span className={`mode-badge badge-${status}`}>
      {count}/{maxGuesses}
    </span>
  );
};

export default ModeBadge;
